import { Component, Injector } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SearchDialogComponent } from '@Work/Accounts/proprietary/controls/search-dialog.component';
import { DataService } from '@Core/services/proprietary/data.service';
import { AppService } from '../../../../../core/services/proprietary/app.service';

@Component({
    standalone: false,
    selector: 'statement-search-dialog',
    templateUrl: './statement-search-dialog.component.html',
    providers: [DataService] //force as a local provider
})
export class StatementSearchDialogComponent extends SearchDialogComponent {
    entityModel: any = {};
    constructor(private injector: Injector, private activeModal: NgbActiveModal, public app: AppService) {
        super(injector);
    }

    //Override Method: called to construct initialize the search component
    initialize(): boolean {
        this.parentActiveModal = this.activeModal;

        this.objectType = 'DBQuery';
        this.model.criteria.Procedure_Name = 'epx_tempstatementsearch';
        this.model.title = 'Select Statement';

        this.model.criteria.Book_Entity_ID = 'CURRENTBOOK';
        this.model.criteria.Max = this.model.currentOptions.maxRows;

        if (!this.model.criteria.View) {
            this.model.criteria.View = 'Full';
        }

        return true;
    }

    setEntity(data) {
        let entity = data[0];

        this.entityModel.EntityID = entity.Entity_ID;
        this.entityModel.EntityName = entity.Entity_Name;
        this.dsCollection.criteria.Entity_ID = entity.Entity_ID;
    }

    clearEntity() {
        this.entityModel = {};
        this.dsCollection.criteria.Entity = '';
    }
}
